export default "__VITE_ASSET__DaRdXeEl__"